const EARTH_RADIUS_KM = 6371
const rad = (deg) => (deg * Math.PI) / 180
const DEFAULT_DIRECTIONS = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW']

export const ORIGIN = { lat: 41.5511, lon: 25.5701 }

export function distanceKm(a, b) {
  const dLat = rad(b.lat - a.lat)
  const dLon = rad(b.lon - a.lon)
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLon / 2) ** 2
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(h))
}

export function compass(a, b, directions = DEFAULT_DIRECTIONS) {
  const y = Math.sin(rad(b.lon - a.lon)) * Math.cos(rad(b.lat))
  const x =
    Math.cos(rad(a.lat)) * Math.sin(rad(b.lat)) -
    Math.sin(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.cos(rad(b.lon - a.lon))
  const bearing = (Math.atan2(y, x) * 180) / Math.PI
  return directions[Math.round(((bearing + 360) % 360) / 45) % 8]
}

// "≈ 13 km W" – straight-line distance and compass direction from Nanovitsa.
// `directions` is the 8-point compass in the active language (N, NE, E, …).
export function describeFromOrigin(place, directions = DEFAULT_DIRECTIONS) {
  if (place.lat == null) return null
  const km = Math.max(1, Math.round(distanceKm(ORIGIN, place)))
  return `≈ ${km} km ${compass(ORIGIN, place, directions)}`
}
